import { NgModule } from '@angular/core';

import { AppGlobals } from '@app/app.global';
import { SharedModule } from '@app/shared';
import { AuthRoutingModule } from './auth-routing.module';
import {
  DemoLoginComponent,
  ForgotPasswordComponent,
  LoginComponent,
  SignupComponent
} from './components';

import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';

@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    DemoLoginComponent
  ],
  imports: [
    AuthRoutingModule,
    SharedModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (AppGlobals: AppGlobals) => {
        return {
          siteKey: AppGlobals.GOOGLE_RECAPTCHA_SITEKEY, // Use the site key from the service
        } as RecaptchaSettings;
      },
      deps: [AppGlobals] // Define dependency
    }
  ],
})
export class AuthModule { }